import { graphql, useStaticQuery } from 'gatsby';

export const useProductsSlug = (locale) => {
  const { allDatoCmsProductsPage } = useStaticQuery(graphql`
    query {
      allDatoCmsProductsPage {
        nodes {
          id: originalId
          locale
          slug
        }
      }
    }
  `);

  const { slug } = allDatoCmsProductsPage.nodes.find((node) => node.locale === locale);
  return { slug };
};
